import { useMemo } from 'react'
import { useAppSelector } from 'redux/toolkit/hooks'
import { EmailLogApiClient } from 'components/pages/emailLog/emailLogApiClient'
import { UrlUtils } from 'v2/modules/lib'

export const useEmailLogApiClient = () => {
  const urlUtils = useMemo(() => UrlUtils(), [])

  const { accessToken } = useAppSelector(_stores => ({
    accessToken: _stores.auth.accessToken || ''
  }))

  return useMemo(() => EmailLogApiClient({ accessToken, urlUtils }), [accessToken, urlUtils])
}
